module.exports = __webpack_public_path__ + "static/media/Background.364ba0fa.svg";